
import Vue from 'vue'
import Component from 'vue-class-component'
import moduleStore from '../../store/videoEditor';
import PageState from '../../store/state';
import { Prop, Watch } from 'vue-property-decorator';
import GeneratePicture from '../generatePicture/generatePicture'
import Subtitles from '../subtitles/subtitles'
import TextTemplate from '../textTemplate/textTemplate'
import { SCREENWHRATIO, WHRATIO } from '../../utils/constant';
import { VFX } from '../../utils/vfx';


type selectType = 'text' | 'img' | 'speakerAudio' | 'backAudio';
type myselect = {
	type: selectType,
	selectIndex: number
}
/**components**/
@Component({
	components: {
		GeneratePicture,
		Subtitles,
		TextTemplate
	}
})
@moduleStore.initVuex({
	mutationNames: moduleStore.mutationNames,
	actionNames: moduleStore.actionNames
})
export default class Player extends Vue {
	@Prop() duration: number;
	@Prop() renderEle: any ;
	@Prop() isPlay: boolean ;
	@Prop() isShowFeedback: boolean;
	@Prop() currPlayTime: number;
	@Prop() scaleRatio:string;
	@Prop() imgLoading:boolean;
	@Prop() imgList: Array<any>;
	@Prop() subtitleInfo: any;
	@Prop() isEdit: boolean;
	@Prop() specialEffectList: Array<any>;
	@Prop() isEditingTextTemplate: boolean
	canvasWidth: number = 7.08;
	ratio = 16/9
	canvasHeight: number = this.ratio * this.canvasWidth
	state = new PageState();
	curImg = 'https://mobvoi-growth-public.ticwear.com/image/moyingongfang/2023-12-14-5292078244433274487.png';
	timeSlider= 0
	curSelect:myselect = {
		type: 'text',
		selectIndex: -1
	}
	isMounted: boolean = false;
	textToImg = {}
	screenVfx: VFX = null
	templateScale = 1;
	created(moduleData: IinjectDatas) {
		this.state = <PageState>moduleData.state;
	}
	@Watch('currPlayTime')
	listenCurrPlayTime(time) {
		if (!this.screenVfx) return
		this.screenVfx.drawVFXByPlay(time)
	}
	mounted() {
		this.isMounted = true;
		this.$emit("renderImg")
		if(this.scaleRatio){
			this.canvasWidth = SCREENWHRATIO[this.scaleRatio].width
			this.canvasHeight = SCREENWHRATIO[this.scaleRatio].height
			const baseFontSize = parseFloat(document.documentElement.style.fontSize)
			this.templateScale = this.canvasWidth * baseFontSize /  WHRATIO[this.scaleRatio].size[0]
		}
		this.$nextTick(() => {
			this.initVFX()
		})
	}
	initVFX() {
		this.screenVfx = new VFX(this.$refs.videoScreenCanvasRef, this.specialEffectList)
	}
	timeSliderChange(){
		this.$emit('playAudio', true)
	}
	tryAudioPlay(type){
		if (!type) {
			this.screenVfx.stop()
		}
		
		this.$emit('playAudio', type)
	}
	get curPlayerTime(){
		return this.currPlayTime
	}
	
	set curPlayerTime(time){
		// 增加isMounted参数，判断进入全屏，未mounted时，短剧不需要手动进行播放或显示
		this.$emit('updateCurrPlayTime', time, this.isMounted)
	}
	
	doFeedback() {
		this.$emit('feedback')
	}
}

